module.exports = __webpack_public_path__ + "static/media/sla-almostExpired.66c8f9e7.svg";